import { WizardStepKey } from '@iheartjane/menu';
import type { WizardFormData } from '@iheartjane/menu';
import { useFetcher } from 'react-router';

import type {
  WizardResultsResponse,
  WizardSelectionsPayload,
} from '@jane/bloom/routes/api.wizard-results/types';
import { buildFormData } from '@jane/bloom/utils/formData';

const mapFormDataToPayload = (
  formData: WizardFormData,
  storeId: number
): WizardSelectionsPayload => ({
  category: formData[WizardStepKey.Category],
  feeling: formData[WizardStepKey.Feelings],
  lineage:
    formData[WizardStepKey.Lineage][0] === 'no-preference'
      ? undefined
      : formData[WizardStepKey.Lineage][0],
  price: formData[WizardStepKey.Price][0] || undefined,
  storeId,
});

interface UseWizardResultsFetcherParams {
  formData: WizardFormData;
  storeId: number;
}

interface UseWizardResultsFetcherReturn {
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  submit: () => void;
  wizardResults?: WizardResultsResponse;
}

export const useWizardResultsFetcher = ({
  formData,
  storeId,
}: UseWizardResultsFetcherParams): UseWizardResultsFetcherReturn => {
  const fetcher = useFetcher<WizardResultsResponse>({
    key: 'wizard-results',
  });

  const submit = () => {
    if (!storeId) return;

    const payload: WizardSelectionsPayload = {
      ...mapFormDataToPayload(formData, storeId),
      storeId,
    };
    fetcher.submit(buildFormData(payload), {
      action: `/api/wizard-results`,
      method: 'post',
    });
  };

  const wizardResults = fetcher.data;
  const isIdle = fetcher.state === 'idle';
  const hasData = !!wizardResults;

  return {
    isError: isIdle && hasData && !wizardResults.success,
    isLoading: !isIdle,
    isSuccess: isIdle && hasData && wizardResults.success,
    submit,
    wizardResults,
  };
};
